export const homePath = () => '/';
export const registerPath = () => '/register';
export const forgotPasswordPath = () => '/forgot-password';
export const changePasswordPath = () => '/change-password';
